import type { Notices } from "@/lib/notices"

const PermissionDenied: Notices.ItemOptions = {
  id: `Geolocation.UseMyLocation.PermissionDenied`,
  message: `Your device denied our request for location access. Please start typing in your address and we'll help you look it up.`,
  type: `warning`,
}

const TimedOut: Notices.ItemOptions = {
  id: `Geolocation.UseMyLocation.TimedOut`,
  message: `The location request timed out. Location access might be disabled in your privacy settings. Please try again, or start typing in your address and we'll help you look it up.`,
  type: `warning`,
}

const Unavailable: Notices.ItemOptions = {
  id: `Geolocation.UseMyLocation.Unavailable`,
  message: `Your device reported that your location is unavailable. Please start typing in your address and we'll help you look it up.`,
  type: `warning`,
}

export const geolocationNotices = {
  UseMyLocation: {
    PermissionDenied,
    TimedOut,
    Unavailable,
  },
}
